import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-8 lg:px-12 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div className="space-y-5">
            <h2 className="font-heading text-2xl md:text-3xl font-bold">
              91EatGossip
            </h2>
            <p className="text-sm text-background-400 leading-relaxed max-w-sm">
              91EatGossip是最专业的中文娱乐八卦资讯门户，为您提供24小时不间断的明星丑闻、网红爆料、综艺内幕、影视资讯等独家内容。高清视频免费观看，第一手爆料实锤证据，吃瓜从未如此畅快！
            </p>
            <div className="flex items-center gap-3 pt-2">
              {[
                { icon: "ri-chat-1-line", label: "站内动态" },
                { icon: "ri-wechat-line", label: "微信" },
                { icon: "ri-telegram-line", label: "Telegram" },
                { icon: "ri-mail-line", label: "邮箱" },
              ].map((social) => (
                <a
                  key={social.label}
                  href="#"
                  className="w-9 h-9 rounded-full border border-background-700 flex items-center justify-center text-background-400 hover:bg-background-800 hover:text-background-200 transition-colors"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-sm`} />
                </a>
              ))}
            </div>
          </div>

          <div className="space-y-6">
            <div>
              <h3 className="text-xs uppercase tracking-wider text-background-500 mb-2">
                联系方式
              </h3>
              <p className="text-sm text-background-300">
                爆料邮箱：hello@msldyun.cn
              </p>
            </div>
            <div>
              <h3 className="text-xs uppercase tracking-wider text-background-500 mb-2">
                商务合作
              </h3>
              <p className="text-sm text-background-300">
                合作邮箱：hello@msldyun.cn
              </p>
            </div>
            <div>
              <h3 className="text-xs uppercase tracking-wider text-background-500 mb-2">
                意见反馈
              </h3>
              <p className="text-sm text-background-300">
                反馈邮箱：hello@msldyun.cn
              </p>
            </div>
          </div>

          <div className="hidden md:block">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20warm%20golden%20light%20leaks%20on%20dark%20background%20artistic%20texture%2C%20cinematic%20grain%20film%20photography%20style%2C%20moody%20dramatic%20atmosphere%20with%20orange%20amber%20tones%20against%20deep%20black%20shadows%2C%20editorial%20art%20composition&width=400&height=500&seq=footer-brand-01&orientation=portrait"
              alt="91EatGossip 品牌视觉"
              className="w-full h-64 object-cover rounded-lg"
              loading="lazy"
            />
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-800/50">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-500">
              © 2026 91EatGossip. All rights reserved. 本站内容仅供娱乐参考。
            </p>
            <div className="flex items-center gap-6">
              <Link
                to="/about"
                className="text-xs text-background-500 hover:text-background-300 transition-colors"
              >
                关于我们
              </Link>
              <a
                href="#"
                className="text-xs text-background-500 hover:text-background-300 transition-colors"
              >
                隐私政策
              </a>
              <a
                href="#"
                className="text-xs text-background-500 hover:text-background-300 transition-colors"
              >
                使用条款
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
